import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useDropzone } from 'react-dropzone'

import { ReactComponent as ReportIcon } from '../../../assets/icons/report.svg'

import Icon from '../../Icon'

import { showToasts } from '../../../helpers/toasts'

import useStyles from './styles'

function DropFileUploader({
  accept,
  multiple,
  uploadText,
  uploadActiveText,
  containerClassName,
  onUpload,
  rejectFileMessage = 'Sorry, that file type is not supported. Please upload an image or video file',
  maxSize = Infinity
}) {
  const classes = useStyles()

  const onDropAccepted = useCallback(
    acceptedFiles => {
      onUpload(multiple ? acceptedFiles : acceptedFiles[0])
    },
    [multiple, onUpload]
  )

  const { getRootProps, getInputProps, isDragActive, isDragReject, isDragAccept, fileRejections } = useDropzone({
    accept,
    multiple,
    onDropAccepted,
    maxSize,
    useFsAccessApi: false
  })

  const className = classnames(classes.baseStyle, {
    [classes.activeStyle]: isDragActive,
    [classes.acceptStyle]: isDragAccept,
    [classes.rejectStyle]: isDragReject || !!fileRejections.length
  })

  useEffect(() => {
    // show error toast when file was rejected
    if (!!fileRejections.length) {
      showToasts({
        type: 'error',
        message: rejectFileMessage
      })
    }
  }, [fileRejections, rejectFileMessage])

  return (
    <div className={classnames(classes.container, containerClassName)}>
      <div {...getRootProps({ className })}>
        <input {...getInputProps()} />
        <p className={classes.actionText}>
          <Icon className={classes.icon}>
            <ReportIcon />
          </Icon>
          {isDragActive ? uploadActiveText || 'Drop files here ...' : uploadText || 'Drop Files Here'}
        </p>
      </div>
    </div>
  )
}

DropFileUploader.propTypes = {
  accept: PropTypes.object,
  multiple: PropTypes.bool,
  uploadText: PropTypes.string,
  rejectFileMessage: PropTypes.string,
  uploadActiveText: PropTypes.string,
  containerClassName: PropTypes.string,
  onUpload: PropTypes.func
}

export default DropFileUploader
